export const setIsDraw = (isDraw) => {
    return {
        type: 'SET_IS_DRAW',
        payload: isDraw,
    };
}
